import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, loginUser } from "../api/budgetPortal";
import { useAuth } from "../state/AuthContext";
import { APP_NAME, TERMS_URL } from "../constants/app";
import { ButtonLoader } from "../components/Loaders";
import Logo from "../assets/image/logo.svg";
import SignupBg from "../assets/image/signupBg.svg";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await loginUser({ email, password });
      if (response?.status !== 200 || !response?.data?.auth_key) {
        setError(response?.message || "Login failed");
        setLoading(false);
        return;
      }

      const profileResponse = await getCurrentUser(response.data.auth_key);
      login(response.data.auth_key, profileResponse?.data ?? response.data);
      navigate("/budget-entry");
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Login failed");
    }

    setLoading(false);
  };

  return (
    <>
      <div className="desktop-nav">
        <div className="desktop-navBrand">
          <img src={Logo} alt={APP_NAME} className="desktop-navLogo" />
          <p>{APP_NAME}</p>
        </div>
      </div>
      <section className="login-container">
        <div className="leftImageSection-leftarea">
          <div
            className="leftImageSection-leftarea-image"
            style={{ backgroundImage: `url(${SignupBg})` }}
            aria-hidden="true"
          />
          <p className="leftImageSection-leftarea-title">
            Enterprise software for preparing financial statements
          </p>

          <div className="leftImageSection-leftarea-logoContainer">
            <img
              src={Logo}
              alt={APP_NAME}
              className="leftImageSection-leftarea-logo"
            />
            <p className="leftImageSection-leftarea-logoText">{APP_NAME}</p>
          </div>
        </div>

        <div className="login-rightarea">
          <form className="login-field-container" onSubmit={handleSubmit}>
            <p className="loginform-title">Log in</p>
            <p className="loginform-secondTitle">Welcome Back to {APP_NAME}</p>

            <label>
              <span className="input-text">Email</span>
              <input
                className="login-textinput"
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </label>

            <label>
              <span className="input-text">Password</span>
              <input
                className="login-textinput"
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>

            {error ? <div className="login-error-message">{error}</div> : null}

            <button type="submit" className="submit-button-login" disabled={loading}>
              <span className="submit-button-text-login">
                {loading ? <ButtonLoader label="Signing in..." /> : "Log in"}
              </span>
            </button>

            <p className="termsCondition">
              By using {APP_NAME}, you agree to our{" "}
              <a
                className="termsCondition-highlight"
                href={TERMS_URL}
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
            </p>
          </form>
        </div>
      </section>
    </>
  );
};

export default LoginPage;
